import React, { useContext, useEffect, useState } from "react";
import Button from "@amzn/meridian/button";
import NormalSettingsView from "./NormalSettingView";
import { SettingsContext } from "./SettingsContext";
import Table, {
  TableCell,
  TableRow,
  TableSectionHeader,
} from "@amzn/meridian/table";
import Modal, { ModalFooter } from "@amzn/meridian/modal";
import Row from "@amzn/meridian/row";
import Text from "@amzn/meridian/text";
import Alert from "@amzn/meridian/alert";
import "rc-time-picker/assets/index.css";
import * as TableCellData from "./tableCellData";
import * as Constants from "./SettingsConstant";
import { validCyclePlan, getShiftTime } from "./SettingsUtil";
import { FormattedMessage } from "react-intl";

const cycleExists = (state, day, cycleName) => {
  let doesCycleExist = 0;
  state[day].some((data) => {
    if (data.planDetails.cycleName === cycleName) {
      doesCycleExist = 1;
    }
    return data.planDetails.cycleName === cycleName;
  });
  return doesCycleExist === 1;
};

//planColour is redundant
const getPlanDetails = (cycleName, cycleId) => {
  const planDetails = {
    planName: cycleName,
    planColor: "#ade422",
    cycleId: cycleId,
    cycleName: cycleName,
  };

  return planDetails;
};

const getProps = (state, data, plan, cell, time) => {
  const props = {
    insights: data,
    plan: plan,
    cell: cell,
    time: time,
    stationTime: state.shiftTimeRange.startTime,
  };
  return props;
};

const SettingsView = () => {
  const [viewState, setViewState] = useState(1);
  const { viewModel, dispatch } = useContext(SettingsContext);
  const state = viewModel.settingsData;

  const renderEditableView = (data) => {
    return (
      <TableRow>
        <TableCell alignmentHorizontal="left">
          {data.planDetails.cycleName}
        </TableCell>

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.taskPlan,
            Constants.induct,
            Constants.startTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.taskPlan,
            Constants.induct,
            Constants.endTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.taskPlan,
            Constants.sort,
            Constants.startTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.taskPlan,
            Constants.sort,
            Constants.endTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.taskPlan,
            Constants.stage,
            Constants.startTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.taskPlan,
            Constants.stage,
            Constants.endTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.breaks,
            Constants.break1,
            Constants.startTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.breaks,
            Constants.break1,
            Constants.endTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.breaks,
            Constants.lunch,
            Constants.startTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.breaks,
            Constants.lunch,
            Constants.endTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.breaks,
            Constants.break2,
            Constants.startTime,
          )}
        />

        <TableCellData.TaskBreaksCell
          data={getProps(
            state,
            data,
            Constants.breaks,
            Constants.break2,
            Constants.endTime,
          )}
        />

        <TableCellData.NodeTargetsCell
          data={{
            insights: data,
            targetMap: Constants.targetMap,
            target: Constants.NODE_TPH,
          }}
        />

        <TableCellData.NodeTargetsCell
          data={{
            insights: data,
            targetMap: Constants.targetMap,
            target: Constants.INDUCT_PPH,
          }}
        />

        <TableCellData.NodeTargetsCell
          data={{
            insights: data,
            targetMap: Constants.targetMap,
            target: Constants.STOW_PPH,
          }}
        />

        <TableCell>
          <Button
            size="small"
            alignmentHorizontal="right"
            onClick={() => updatePlan(data, state.shiftTimeRange)}
          >
            Save
          </Button>
        </TableCell>

        {validCyclePlan(data) ? (
          <TableCell>
            <Button
              size="small"
              alignmentHorizontal="right"
              onClick={() => deletePlan(data)}
            >
              Delete
            </Button>
          </TableCell>
        ) : null}
      </TableRow>
    );
  };

  const updatePlan = (plan, shiftTimeRange) => {
    dispatch({
      type: "UPDATE_PLAN",
      data: {
        dispatcher: dispatch,
        planData: plan,
        shiftTimeRange: shiftTimeRange,
      },
    });
  };

  const deletePlan = (plan) => {
    dispatch({
      type: "DELETE_PLAN",
      data: { dispatcher: dispatch, planData: plan },
    });
    setViewState(1);
  };

  useEffect(() => {
    dispatch({ type: "LOAD_VIEW", data: { dispatcher: dispatch } });
  }, []);

  return viewState === 1 ? (
    <div>
      <div className="settingsEditButton">
        <Button
          size="small"
          onClick={() => {
            setViewState(0);
          }}
        >
          Edit
        </Button>
      </div>
      <div className="reset-time-text">
        {state.shiftTimeRange ? (
          <Text type="h200">
            {state.shiftTimeRange !== undefined &&
            state.shiftTimeRange.endTime !== undefined
              ? "Reset Time - " + getShiftTime(state.shiftTimeRange.endTime)
              : ""}
          </Text>
        ) : null}
      </div>
      <Modal
        type="dialog"
        open={
          viewModel.showDeletePlanResponseModal === Constants.MODAL_SUCCESS ||
          viewModel.showDeletePlanResponseModal === Constants.MODAL_ERROR
        }
        closeLabel="Close"
        describedById="modal-description"
      >
        <div>
          <Alert
            type={
              viewModel.showDeletePlanResponseModal === Constants.MODAL_SUCCESS
                ? "success"
                : "error"
            }
            size="xlarge"
          >
            <FormattedMessage
              id={viewModel.messageToDisplay}
              defaultMessage="PLAN DELETE STATUS"
            ></FormattedMessage>
          </Alert>
        </div>
        <ModalFooter>
          <Row alignmentHorizontal="right" widths="fit">
            <Button
              type="secondary"
              size="small"
              onClick={() =>
                dispatch({
                  type: "SHOW_DELETE_PLAN_RESPONSE_MODAL",
                  modalState: Constants.MODAL_RESET,
                })
              }
            >
              Close
            </Button>
          </Row>
        </ModalFooter>
      </Modal>

      <NormalSettingsView data={{ viewModel: viewModel, dispatch: dispatch }} />
    </div>
  ) : (
    <div>
      <div className="settingsEditButton">
        <Button
          size="small"
          onClick={() => {
            setViewState(1);
          }}
        >
          Back
        </Button>
      </div>
      <div className="reset-time-text">
        {state.shiftTimeRange ? (
          <Text type="h200">
            {state.shiftTimeRange !== undefined &&
            state.shiftTimeRange.endTime !== undefined
              ? "Reset Time - " + getShiftTime(state.shiftTimeRange.endTime)
              : ""}
          </Text>
        ) : null}
      </div>

      <Modal
        type="dialog"
        open={
          viewModel.showUpdatePlanResponseModal === Constants.MODAL_SUCCESS ||
          viewModel.showUpdatePlanResponseModal === Constants.MODAL_ERROR
        }
        closeLabel="Close"
        describedById="modal-description"
      >
        <div>
          <Alert
            type={
              viewModel.showUpdatePlanResponseModal === Constants.MODAL_SUCCESS
                ? "success"
                : "error"
            }
            size="xlarge"
          >
            <FormattedMessage
              id={viewModel.messageToDisplay}
              defaultMessage="PLAN UPDATE STATUS"
            ></FormattedMessage>
          </Alert>
        </div>
        <ModalFooter>
          <Row alignmentHorizontal="right" widths="fit">
            <Button
              type="secondary"
              size="small"
              onClick={() =>
                dispatch({
                  type: "SHOW_UPDATE_PLAN_RESPONSE_MODAL",
                  modalState: Constants.MODAL_RESET,
                })
              }
            >
              Close
            </Button>
          </Row>
        </ModalFooter>
      </Modal>

      <div>
        <Table headerRows={2} spacing="none">
          <TableRow>
            <TableCell columnSpan={2} alignmentHorizontal="right">
              Induct
            </TableCell>
            <TableCell columnSpan={2} alignmentHorizontal="right">
              Stow
            </TableCell>
            <TableCell columnSpan={2} alignmentHorizontal="right">
              Stage
            </TableCell>
            <TableCell columnSpan={2} alignmentHorizontal="right">
              Break1
            </TableCell>
            <TableCell columnSpan={2} alignmentHorizontal="right">
              Lunch
            </TableCell>
            <TableCell columnSpan={2} alignmentHorizontal="right">
              Break2
            </TableCell>
            <TableCell columnSpan={3} alignmentHorizontal="right">
              NodeTargets
            </TableCell>
          </TableRow>

          <TableRow>
            <TableCell alignmentHorizontal="left">Cycle</TableCell>
            <TableCell alignmentHorizontal="center">Start</TableCell>
            <TableCell alignmentHorizontal="center">End</TableCell>
            <TableCell alignmentHorizontal="center">Start</TableCell>
            <TableCell alignmentHorizontal="center">End</TableCell>
            <TableCell alignmentHorizontal="center">Start</TableCell>
            <TableCell alignmentHorizontal="center">End</TableCell>
            <TableCell alignmentHorizontal="center">Start</TableCell>
            <TableCell alignmentHorizontal="center">End</TableCell>
            <TableCell alignmentHorizontal="center">Start</TableCell>
            <TableCell alignmentHorizontal="center">End</TableCell>
            <TableCell alignmentHorizontal="center">Start</TableCell>
            <TableCell alignmentHorizontal="center">End</TableCell>
            <TableCell alignmentHorizontal="center">Target TPH</TableCell>
            <TableCell alignmentHorizontal="center">Induct PPH</TableCell>
            <TableCell alignmentHorizontal="center">Stow PPH</TableCell>
          </TableRow>
          {Constants.days.map((day) => {
            if (!state[day]) {
              state[day] = [];
            }

            state.cycleInfoList.forEach((cycle) => {
              if (!cycleExists(state, day, cycle.cycleName)) {
                state[day][state[day].length] = {};
                state[day][state[day].length - 1]["planDetails"] =
                  getPlanDetails(cycle.cycleName, cycle.cycleId);
              }
            });
            return [
              <TableSectionHeader>{day}</TableSectionHeader>,
              state[day].map((data) => {
                return renderEditableView(data);
              }),
            ];
          })}
        </Table>
      </div>
    </div>
  );
};

export default SettingsView;



// WEBPACK FOOTER //
// ./src/components/settings/SettingsView.js